export default "__VITE_ASSET__DROH58O2__"